import { ILogger } from "./logger";

const consoleLogger: ILogger = {
    debug: console.debug,
    info: console.log,
    warning: console.warn,
    error: console.error,
};

export default consoleLogger;
